import envDefault from './../util/envDefault';

const ajaxErrors =
  {
    4: {
      title: 'Client error [statusCode].',
      message: 'An error has occurred on the server, please notify <a href="mailto:'+ envDefault('ilis.support.email', 'ILIS.Support@nt.gov.au') +'">ILIS Support</a> of this problem.'
    },
    401: {
      title: 'Your session has timed out.',
      message: 'If you have unsaved changes close this popup, save any entered text and reload this Page, otherwise click Reload.',
      reload: true
    },
    403: {
      title: 'You don\'t have access to the requested resource.',
      message: 'You are missing the required permissions to access this resource. If you think this is incorrect, please contact <a href="mailto:'+ envDefault('ilis.support.email', 'ILIS.Support@nt.gov.au') +'">ILIS Support</a>.'
    },
    404: {
      title: 'The Resource you requested does not exist.',
      message: 'An error has occurred on the server, please notify <a href="mailto:'+ envDefault('ilis.support.email', 'ILIS.Support@nt.gov.au') +'">ILIS Support</a> of this problem.'
    },
    5: {
      title: 'Server error [statusCode].',
      message: 'An error has occurred on the server, please notify <a href="mailto:'+ envDefault('ilis.support.email', 'ILIS.Support@nt.gov.au') +'">ILIS Support</a> of this problem.'
    },
    500: {
      title: 'A major problem has been encountered.',
      message: '<p>The action you were trying to perform has encountered a major error. Changes you were making to data may not have been saved.</p>' +
        '<a>Please notify <a href="mailto:'+ envDefault('ilis.support.email', 'ILIS.Support@nt.gov.au') +'">ILIS Support</a> of this problem and quote the following error reference: [errorRef]</p>' +
        '<p>You may continue to use ' + envDefault('app.name', 'Subdivision Development Guidelines Online') + ' however repeating your last action will most likely result in another error.</p>'
    },
    fallback: {title: 'A major problem has been encountered.', message: 'An error has occurred, please notify <a href="mailto:'+ envDefault('ilis.support.email', 'ILIS.Support@nt.gov.au') +'">ILIS Support</a> of this problem.'},
  };

export class AjaxErrorTranslator {

  static getErrorObjectForStatusCode(statusCode) {
    var statusObj = ajaxErrors[statusCode];

    if (statusObj) {
      return AjaxErrorTranslator.makeErrorsObject(statusObj.title, statusObj.message, statusObj.hasOwnProperty('reload'));
    }
  }

  static buildErrorObject(statusCode, response) {

    var replacementVariables = {};
    var errorObj;

    if (statusCode) {
      replacementVariables["statusCode"] = statusCode
      if (statusCode === 500 && response) {
        var responseObj = response;

        replacementVariables["errorRef"] = responseObj.exceptionId;
      }

      errorObj = AjaxErrorTranslator.getErrorObjectForStatusCode(statusCode);

      if (!errorObj) {
        errorObj = AjaxErrorTranslator.getErrorObjectForStatusCode(statusCode.toString()[0]);
      }
    }

    if (!errorObj) {
      errorObj = AjaxErrorTranslator.getErrorObjectForStatusCode("fallback");
    }

    //do replacement
    for (var replVar in replacementVariables) {
      if (replacementVariables.hasOwnProperty(replVar)) {
        var value = replacementVariables[replVar];
        errorObj.message = errorObj.message.replace("[" + replVar + "]", value);
        errorObj.title = errorObj.title.replace("[" + replVar + "]", value);
      }
    }

    return errorObj;
  }

  static makeErrorsObject(title, message, showReload) {
    return {
      title: title,
      message: message,
      reload: showReload
    };
  }

}


export default ajaxErrors;

